export const analytics = null;

export const logAnalyticsEvent = (eventName, params) => {
  // Firebase not configured — analytics disabled
};
